module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-chunk-intro-card01@2x.b4b449cb.jpg";